import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea'; // Import InputTextarea

const UserForm = () => {
  const [isSavePopupOpen, setIsSavePopupOpen] = useState(false);
  const [customMessage, setCustomMessage] = useState('');

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      customMessage: ''
    },
    onSubmit: (values) => {
      console.log('Form Data:', values);
    },
  });

  const openSavePopup = (e) => {
    e.preventDefault();
    setIsSavePopupOpen(true);
  };

  const handleSaveSubmit = (e) => {
    e.preventDefault();
    formik.setFieldValue('customMessage', customMessage, true);
    setIsSavePopupOpen(false);
    formik.handleSubmit();
  };

  return (
    <div className="form-container" style={{ padding: '20px' }}>
      <h2>User Information Form</h2>
      <form onSubmit={openSavePopup}>
        <div className="p-field">
          <label htmlFor="firstName">First Name</label>
          <InputText
            id="firstName"
            name="firstName"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            style={{ width: '100%' }}
          />
        </div>
        <div className="p-field">
          <label htmlFor="lastName">Last Name</label>
          <InputText
            id="lastName"
            name="lastName"
            value={formik.values.lastName}
            onChange={formik.handleChange}
            style={{ width: '100%' }}
          />
        </div>
        <div className="p-field">
          <label htmlFor="email">Email</label>
          <InputText
            id="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            style={{ width: '100%' }}
          />
        </div>
        <div className="p-field">
          <label htmlFor="phone">Phone</label>
          <InputText
            id="phone"
            name="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
            style={{ width: '100%' }}
          />
        </div>
        <Button type="submit" label="Submit" className="p-mt-2" />
      </form>

      <Dialog header="Enter a Custom Message" visible={isSavePopupOpen} style={{ width: '50vw' }} dismissableMask={true} onHide={() => setIsSavePopupOpen(false)}>
        <div className="card">
          <form onSubmit={handleSaveSubmit} className="">
            <div className="formgrid grid">
              <div className="col-12 pt-2">
                <label htmlFor="customMessage">Message</label>
                <InputTextarea
                  id="customMessage"
                  value={customMessage}
                  onChange={(e) => setCustomMessage(e.target.value)}
                  className="p-inputtext p-component"
                  style={{ width: '100%', height: '100px' }}
                />
              </div>
              <div className="card flex flex-wrap justify-content-center gap-3">
                <Button label="Save" type="submit" className="p-2" />
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </div>
  );
};

export default UserForm;
